import { ICustomSize, ICustomSizeValues } from '@vfit/shared/models';

const DEFAULT_SIZE: ICustomSize = {
  default: {
    width: 405,
  },
  tablet: {
    width: 327,
  },
  mobile: {
    width: 327,
  },
};

/**
 * Return the size of slide
 * @param slideIndex
 * @param isMobile
 * @param isTablet
 */
const getSlideSize = (
  slideIndex: number,
  isMobile: boolean,
  isTablet: boolean
): ICustomSizeValues => {
  if (!isMobile && !isTablet) return DEFAULT_SIZE.default;
  return isMobile ? DEFAULT_SIZE.mobile : DEFAULT_SIZE.tablet || DEFAULT_SIZE.default;
};

export { getSlideSize, DEFAULT_SIZE };
